module.exports = __webpack_public_path__ + "45adacfc911a902404a86244c89fc204.png";